export const RetailerOrderStatus = Object.freeze({
  NEW: "NEW",
  IN_REVIEW: "IN_REVIEW",
  IN_PROGRESS: "IN_PROGRESS",
  IN_PRODUCTION: "IN_PRODUCTION",
  SENT_TO_CUSTOMER: "SENT_TO_CUSTOMER"
});
